import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import BackLink from '../components/BackLink'
import Layout from '../components/Layout'
import TournamentDetailPanel from '../components/TournamentDetailPanel'
import { useUser } from '../contexts/UserContext'

export default function TournamentView() {
  const navigate = useNavigate()
  const { id } = useParams()
  const { user } = useUser()

  // DUB-71 / DUB-72: when an admin is in sticky admin mode (set in Layout
  // and persisted to localStorage), browser-back can drop them on this
  // user-facing page with the admin nav still on top. The page content
  // then shows user-mode (with an "Open in Admin" link) while the chrome
  // says admin — confusing and inconsistent. Auto-redirect to the admin
  // variant when the user is in sticky admin mode. To genuinely view the
  // player version, the admin must first click "User Dashboard",
  // which clears the sticky flag.
  useEffect(() => {
    if (user?.role !== 'admin') return
    if (!id) return
    let sticky = false
    try { sticky = localStorage.getItem('dub_admin_mode_sticky') === '1' } catch { /* ignore */ }
    if (sticky) {
      navigate(`/admin/tournaments/${id}/edit`, { replace: true })
    }
  }, [user, id, navigate])

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Back Navigation */}
        {/* Admin/user path separation (2026-04-23): this page is the USER
            tournament detail. Back arrow goes to the user tournament list for
            everyone — admins who want the admin flow use the "Open in Admin"
            escape hatch on the right side. Do NOT route admins to the admin
            dashboard from here; that breaks the rule that admin and user
            paths stay distinct. */}
        <div className="mb-4 flex items-center justify-between gap-3">
          <BackLink label="Tournaments" to="/tournaments" />
          {user?.role === 'admin' && (
            <button
              type="button"
              onClick={() => navigate(`/admin/tournaments/${id}/edit`)}
              className="text-sm text-primary hover:underline"
            >
              Open in Admin
            </button>
          )}
        </div>

        <TournamentDetailPanel tournamentId={id} />
      </div>
    </Layout>
  )
}
